var _style, _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 256 256",
    style: {
      enableBackground: "new 0 0 256 256"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#28C937;}\n\t.st1{fill:#FFFFFF;}\n")), _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 1.7.22")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(128 128) scale(0.72 0.72)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-175.05 -175.05000000000004) scale(3.89 3.89)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 45,
    cy: 45,
    r: 45
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M38.5,64.5C38.5,64.5,38.5,64.5,38.5,64.5c-1.3,0-2.6-0.6-3.4-1.6L21.6,47.3c-1.6-1.9-1.4-4.7,0.5-6.3 c1.9-1.6,4.7-1.4,6.3,0.5l10.1,11.7L61.6,27c1.6-1.9,4.5-2,6.4-0.4c1.9,1.6,2,4.5,0.4,6.4L41.9,63C41,63.9,39.8,64.5,38.5,64.5z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.31f408e5397a25b8a94598eb55024394.svg";
export { ForwardRef as ReactComponent };